import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gateways/paypal.png")